export default {
    routerName: '辞書詳細',
    dict: {
        category: 'カテゴリー',
        label: 'ラベル',
        sortOrder: 'ソート',
        data1: 'データ1',
        data2: 'データ2',
        data3: 'データ3',
        data4: 'データ4',
        data5: 'データ5',
        data6: 'データ6',
        data7: 'データ7',
        data8: 'データ8',
        data9: 'データ9',
        data10: 'データ10',
        status: '状態',
        open: '有効',
        close: '無効',
        createBy: '作成者',
        createTime: '作成日付',
        updateBy: '更新者',
        updateTime: '更新日付',
        body: '内容',
        hasBody: '有',
        hasNotBody: '無',
    },
};
